import $foreign from "./foreign.cjs";
var _decodeURI = $foreign._decodeURI;
var _decodeURIComponent = $foreign._decodeURIComponent;
var _encodeURI = $foreign._encodeURI;
var _encodeURIComponent = $foreign._encodeURIComponent;
var _toExponential = $foreign._toExponential;
var _toFixed = $foreign._toFixed;
var _toPrecision = $foreign._toPrecision;
var infinity = $foreign.infinity;
var $$isFinite = $foreign.isFinite;
var $$isNaN = $foreign.isNaN;
var nan = $foreign.nan;
var readFloat = $foreign.readFloat;
var readInt = $foreign.readInt;
export { _decodeURI, _decodeURIComponent, _encodeURI, _encodeURIComponent, _toExponential, _toFixed, _toPrecision, infinity, $$isFinite as isFinite, $$isNaN as isNaN, nan, readFloat, readInt };
